<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ 'Liste Sonderinspektion' | mrTranslate }}{{ titel }}</span>
    </div>
    <div class="header-actions">
      <a href="javascript://" class="nav-link nav-icon">
        <cds-icon shape="times" (click)="close()"></cds-icon>
      </a>
    </div>
  </header>

  @if (sonderPruefungen?.rows) {
    <div class="clr-row nxm" style="align-items: center">
      <div class="clr-col-auto margin-12-tb">
        <div class="btn-group btn-primary btn-icon">
          <button class="btn btn-icon" [title]="'Neu' | mrTranslate" (click)="showNewSi()" [disabled]="osispkID == 0">
            <cds-icon shape="file" />
          </button>
          <button
            class="btn btn-icon btn-success"
            [title]="'Sonderinspektion beenden' | mrTranslate"
            (click)="exitSi()"
            [disabled]="osispkID == 0">
            <cds-icon shape="success-standard" />
          </button>
          @if (selecteditemMangel) {
            <button
              class="btn btn-icon btn-warning"
              [title]="'Sonderinspektion bearbeiten' | mrTranslate"
              (click)="editSi()">
              <cds-icon shape="note" />
            </button>
            @if (authService?.token?.rights?.status > 5) {
              <button
                class="btn btn-icon btn-danger"
                [title]="'Sonderinspektion löschen' | mrTranslate"
                (click)="deleteSi()">
                <cds-icon shape="times" />
              </button>
            }
          }
        </div>
      </div>
    </div>
    <clr-datagrid
      class="datagrid-compact"
      style="height: calc(50% - 80px); padding-top: 5px; padding-left: 10px; padding-right: 10px"
      [clrDgSelectionType]="'single'"
      [clrDgSelected]="[selecteditem]"
      (clrDgSelectedChange)="selecteditem = $event[0]; selectionTabelleTitelChanged($event[0])"
      [clrDgItemsIdentityFn]="row => row?.OMAZSID">
      @for (column of sonderPruefungen?.columns; track $index) {
        <clr-dg-column [clrDgField]="column.id" [title]="column.id">
          <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['osispkid'] }">
            {{ column.id | titlecase }}
          </ng-container>
        </clr-dg-column>
      }
      <ng-template
        clrVirtualScroll
        let-row
        let-index="index"
        [clrVirtualRowsOf]="sonderPruefungen?.rows"
        [clrVirtualRowsTrackBy]="(_, row) => row?.OMAZSID">
        <clr-dg-row [clrDgItem]="row">
          @for (cell of sonderPruefungen?.columns; track $index) {
            @if (iconColumns.indexOf(cell.id.toLowerCase()) == -1) {
              <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
            } @else {
              <clr-dg-cell>
                <cds-icon
                  class="grid-icon fill-black"
                  [shape]="row['Typ'] ? 'objekttyp' + row['Typ'] : 'unknown-status'"
                  size="22" />
              </clr-dg-cell>
            }
          }
        </clr-dg-row>
      </ng-template>
      <clr-dg-footer>{{ sonderPruefungen?.rows?.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
    </clr-datagrid>
    @if (osispkID != 0 && sonderPruefunglTable?.columns?.length != 0) {
      @if (sonderPruefunglTable?.columns?.length != 0) {
        <clr-datagrid
          class="datagrid-compact"
          style="height: calc(50% - 90px); padding-top: 5px; padding-left: 10px; padding-right: 10px"
          [clrDgSelectionType]="'single'"
          [clrDgSelected]="[selecteditemMangel]"
          (clrDgSelectedChange)="selecteditemMangel = $event[0]; selectionTabelleItemChanged($event[0])">
          <clr-dg-column [style.width.px]="15">{{ 'Medien' | mrTranslate }}</clr-dg-column>
          @for (column of sonderPruefunglTable.columns; track column) {
            <clr-dg-column [clrDgField]="column.id" [style.min-width.px]="column.id.length * 7.5 + 26">
              <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['sp', 'lf', 'st', 'rep'] }">
                {{ column.id | titlecase | mrTranslate }}
              </ng-container>
            </clr-dg-column>
          }
          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="sonderPruefunglTable.rows"
            [clrVirtualRowsTrackBy]="(_, row) => row?.id">
            <clr-dg-row [clrDgItem]="row">
              <clr-dg-cell>
                <a
                  href="javascript:void(0);"
                  (click)="mangelMedia = media.parseMediaPath(row.bild)"
                  [class.deactivate]="!row.bild">
                  <cds-icon [shape]="!row.bild ? 'blank' : 'image-gallery'" />
                </a>
              </clr-dg-cell>
              @for (cell of sonderPruefunglTable.columns; track cell) {
                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
              }
            </clr-dg-row>
          </ng-template>
          <clr-dg-footer>{{ sonderPruefunglTable.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      }
    }
    <br />
    <br />
  } @else {
    <div class="container_innen">
      <div class="clr-row">
        @if (loading) {
          <div class="clr-col-auto">
            <span style="margin-top: 20px" class="spinner spinner-md">Loading...</span>
          </div>
        }
        <div class="clr-col" style="text-align: center;">
          <h3>{{ textpreview }}</h3>
        </div>
      </div>
    </div>
  }
</div>

<app-sonderinspektionmodal></app-sonderinspektionmodal>

@if (mangelMedia) {
  <app-mediaviewmodal
    (onClose)="mangelMedia = undefined"
    [srcs]="mangelMedia"
    [getMediaFromServerAll]="media.getApiFunctionMedia"
    [getBigFileFnc]="media.getApiFunctionMediaBig"
    (openPdfOverlay)="openPdf($event)" />
}

<clr-modal [(clrModalOpen)]="objekteSonderModal" [clrModalClosable]="true" [clrModalSize]="'lg'">
  <h3 class="modal-title">{{ 'Sonderinspektion dokumentieren' | mrTranslate }}</h3>
  <div class="modal-body">
    <h4>{{ 'Mangel' | mrTranslate }}: {{ mangel }}</h4>
    <hr />
    <br />
    <form clrForm ngForm [formGroup]="formGroupSI" #f="ngForm" clrLayout="horizontal" clrLabelSize="8">
      <clr-date-container>
        <label class="clr-col-md-2">{{ 'Datum' | mrTranslate }}</label>
        <input
          clrDate
          name="Datum"
          autocomplete="off"
          type="date"
          [ngModel]="formGroupSI.controls['datum'].value | localeDate"
          (ngModelChange)="formGroupSI.controls['datum'].setValue(localeDate.tosql($event))"
          [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
          required />
        <clr-control-error *clrIfError="'required'">
          {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
        </clr-control-error>
      </clr-date-container>

      <clr-datalist-container class="zustand-width">
        <label class="clr-col-md-2">{{ 'Zustand' | mrTranslate }}</label>

        <input clrDatalistInput formControlName="zustand" required autocomplete="off" />

        <datalist>
          @for (item of items; track item) {
            <option [value]="item"></option>
          }
        </datalist>

        <clr-control-error *clrIfError="'required'">
          {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
        </clr-control-error>
      </clr-datalist-container>

      <!-- <clr-datalist-container>
        <label class="clr-col-md-2">{{"Zustand" | mrTranslate}}</label>
        <input clrDatalistInput formControlName="zustand" autocomplete="off" style="min-width: 650px;"/>
        <datalist>
          <option *ngFor="let item of items" [value]="item" required></option>
        </datalist>
        <clr-control-error *clrIfError="'required'">
          {{"Das Feld muss ausgefüllt werden" | mrTranslate}}
        </clr-control-error>
      </clr-datalist-container> -->

      <clr-textarea-container>
        <label class="clr-col-md-2">{{ 'Bemerkung' | mrTranslate }}</label>
        <textarea
          id="aa"
          class="clr-col-md-10"
          clrTextarea
          formControlName="bemerkung"
          style="width: 100%; height: 150px"></textarea>
      </clr-textarea-container>

      <br />
      <div class="clr-col-12">
        <app-preview-thumbnails
          #aktiv
          [acceptTypes]="'.jpg'"
          [maxAmount]="6"
          [allowCameraVideo]="false"></app-preview-thumbnails>
      </div>
      <br />
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="newSi()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="objekteSonderModal = false">{{ 'Abbrechen' | mrTranslate }}</button>
  </div>
</clr-modal>
